<template>
  <v-img
    class="keyprod-avatar"
    cover
    :alt="alt"
    :height="`${size}!important`"
    :width="`${size}!important`"
    :max-height="`${size}!important`"
    :max-width="`${size}!important`"
    :src="computedAvatar"
  />
</template>

<script setup>
import { computed } from 'vue';
import useAuth from '~/composables/useAuth';

const props = defineProps({
  /**
     * Avatar url
     */
  avatarUrl: {
    type: String,
    default: '',
  },
  /**
     * Size of the avatar (it's a square btw)
     */
  size: {
    type: String,
    default: '7rem',
  },
  /**
     * Size of the avatar (it's a square btw)
     */
  alt: {
    type: String,
    default: 'avatar',
  },
});

const { defaultAvatar } = useAuth();

const computedAvatar = computed(() => props.avatarUrl || `data:image/png;base64,${defaultAvatar}`);
</script>

<style lang="scss">
  .keyprod-avatar {
    border-radius: 50%;

    .v-image__image, .v-image__placeholder {
      width: 100% !important;
      height: 100% !important;
      max-width: 100% !important;
      max-height: 100% !important;
    }
  }
</style>
